module.exports = __webpack_public_path__ + "img/topic_top.829324a3.png";